import ConfirmarExclusao from 'global/guides/Dialog/ConfirmarExclusao'
import { useFeriadosClienteOutletContext } from 'pages/FeriadosCliente.context'
import React from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { feriadosCliente } from 'service/api'
import { toast } from 'sonner'

const ExcluirFeriadoModal: React.FC = () => {
    const { data } = useFeriadosClienteOutletContext()
    const { feriadoId } = useParams()
    const navigate = useNavigate()

    const { mutate } = feriadosCliente.mutations.useDelete({
        invalidateQuery: true,
    })

    const toggle = () => navigate(-1)

    const handleSubmit = () => {
        mutate(+feriadoId!, {
            onSuccess: () => {
                toast.success('Feriados excluido com sucesso!')
                toggle()
            },
            onError: () => {
                toast.error('Erro ao excluir o feriado!')
            },
        })
    }

    return (
        <ConfirmarExclusao
            permissao={['delete', 'Feriados']}
            onConfirm={handleSubmit}
            fecharAoConfirmar={false}
            title={
                <>
                    Deseja realmente excluir o feriado{' '}
                    {data?.find(feriado => feriado.id === +feriadoId!)?.nome}?
                </>
            }
        />
    )
}

export default ExcluirFeriadoModal
